import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut } from "lucide-react";

export const ExternalLayout = ({ children, title = null }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <div className="min-h-screen bg-white" data-testid="external-layout">
      <header className="border-b border-neutral-200 bg-white sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/portal" className="block" data-testid="brand-link-customer">
            <div className="font-display text-lg leading-none" style={{ color: "#183153" }}>
              AppWerkstatt
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-neutral-500 mt-0.5">Kundenportal</div>
          </Link>
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-xs text-neutral-700">{user?.name}</div>
              <div className="font-mono text-[10px] text-neutral-500">{user?.email}</div>
            </div>
            <button
              onClick={onLogout}
              data-testid="logout-button-customer"
              className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 border border-neutral-300 hover:bg-neutral-50 rounded-sm"
            >
              <LogOut className="w-3.5 h-3.5" /> Abmelden
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-8 md:py-12">
        {title && <h1 className="font-display text-3xl md:text-4xl text-neutral-900 mb-8">{title}</h1>}
        {children}
      </main>
      <footer className="max-w-3xl mx-auto px-5 py-10 mt-12 border-t border-neutral-200">
        <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-500">
          AppWerkstatt Portal · Vertraulich · Audit-fähig
        </div>
      </footer>
    </div>
  );
};
